import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import styles from './DocumentView.module.scss'
import { getDocument, getDocflowEmployees } from '../../../../service/DocflowService'
import DocHeader from './DocHeader'
import DocBody from './DocBody'
import DocActions from './DocActions'
import DocComments from './DocComments'
import DocHistory from './DocHistory'
import AttachmentsList from './AttachmentsList'
import CreateDocModal from '../CreateDocModal/CreateDocModal'

export default function DocumentView({ docId, onClose }) {
  const [doc, setDoc]           = useState(null)
  const [loading, setLoading]   = useState(true)
  const [panel, setPanel]       = useState('actions')
  const [employees, setEmployees] = useState([])
  const [editOpen, setEditOpen] = useState(false)

  useEffect(() => {
    getDocflowEmployees().then(r => setEmployees(r.data)).catch(() => {})
  }, [])

  useEffect(() => {
    if (!docId) return
    setLoading(true)
    getDocument(docId)
      .then(r => setDoc(r.data))
      .finally(() => setLoading(false))
  }, [docId])

  function handleUpdated(newDoc) {
    setDoc(newDoc)
  }

  const panelTabs = [
    { key: 'actions',  label: '⚡ Действия с документом' },
    { key: 'comments', label: `💬 Переписка${doc?.comments?.length ? ` (${doc.comments.length})` : ''}` },
    { key: 'history',  label: `📋 История движения${doc?.activities?.length ? ` (${doc.activities.length})` : ''}` },
  ]

  const modal = (
    <div className={styles.overlay} onMouseDown={e => e.target === e.currentTarget && onClose()}>
      <div className={styles.viewModal}>
        {/* ─── Top bar ─── */}
        <div className={styles.viewTopBar}>
          <button className={styles.backBtn} onClick={onClose}>← Закрыть</button>
          {doc && (
            <div className={styles.topBarInfo}>
              <span className={styles.topBarRegNum}>№ {doc.reg_number}</span>
              <span className={styles.topBarDot}>•</span>
              <span className={styles.topBarType}>{doc.doc_type_display}</span>
              {doc.status_display && (
                <span className={styles.topBarStatus} data-status={doc.status}>
                  {doc.status_display}
                </span>
              )}
            </div>
          )}
          <div style={{ flex: 1 }} />
          <button className={styles.closeBtn2} onClick={onClose} title="Закрыть">×</button>
        </div>

        {loading ? (
          <div className={styles.loadingState}>
            <div className={styles.spinner} />
            <p>Загрузка документа…</p>
          </div>
        ) : !doc ? (
          <div className={styles.loadingState}>
            <p>Документ не найден</p>
          </div>
        ) : (
          <div className={styles.viewBody}>
            {/* ─── Left: Document + Attachments ─── */}
            <div className={styles.leftPanel}>
              <DocHeader doc={doc} />
              <div className={styles.divider} />
              <DocBody doc={doc} />
              <div className={styles.divider} />
              <AttachmentsList
                docId={doc.id}
                attachments={doc.attachments}
                isCreator={doc.my_role === 'creator'}
              />
            </div>

            {/* ─── Right: Tabs ─── */}
            <div className={styles.rightPanel}>
              <div className={styles.panelTabs}>
                {panelTabs.map(t => (
                  <button
                    key={t.key}
                    className={`${styles.panelTab} ${panel === t.key ? styles.panelTabActive : ''}`}
                    onClick={() => setPanel(t.key)}
                  >
                    {t.label}
                  </button>
                ))}
              </div>

              <div className={styles.panelContent}>
                {panel === 'actions' && (
                  <DocActions
                    doc={doc}
                    myRole={doc.my_role}
                    onUpdated={handleUpdated}
                    employees={employees}
                    onEdit={() => setEditOpen(true)}
                  />
                )}
                {panel === 'comments' && (
                  <DocComments
                    docId={doc.id}
                    comments={doc.comments}
                    onCommentsChange={updated => setDoc(d => ({ ...d, comments: updated }))}
                  />
                )}
                {panel === 'history' && (
                  <DocHistory activities={doc.activities || []} />
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )

  return (
    <>
      {ReactDOM.createPortal(modal, document.body)}
      {editOpen && doc && (
        <CreateDocModal
          editDoc={doc}
          onClose={() => setEditOpen(false)}
          onUpdated={updated => { handleUpdated(updated); setEditOpen(false) }}
        />
      )}
    </>
  )
}
